import DateRangePicker from "../../../components/DateRangePicker";
import { formatPrice, formatCPM, gaSendEvent, GTMEvent } from "../../../utils/Utils";
import BrandCategorySelector from "../../../components/BrandCategorySelector";
import Billboards from "../../../libs/API/Billboards";
import BrandSelector from "../../../components/BrandSelector";
import ClientSelector from '../../../components/ClientSelector';
import Auth from "../../../libs/API/Auth";


class BillboardDetailPriceDetail{
    constructor(billboardFormatId, billboardId, billboardName){
        this.main = document.getElementById('billboard_detail_price_detail');

        this.dateRangePicker = DateRangePicker;
        this.dateRangePicker.recurrencesDay = true; /* Bandera del flujo con seleccion de dias */
        this.dataPrice = null;
        this.dataName = billboardName;
        this.dataId = billboardId;
        // this._reach = this.main.querySelector('.reach');
        this._cpm = this.main.querySelector('.cpm');
        this._avgDayPrice = this.main.querySelector('.avg_day_price');
        this._priceElements = Array.from(this.main.querySelectorAll('.price'));
        this._daysAvailableBtn = this.main.querySelector('.days_available_btn');
        this._brandCategorySelector = new BrandCategorySelector(this.main.querySelector('.brand-category-selector'));

        this._addToListBtn = this.main.querySelector('.add_to_list_btn');

        this._listPriceHolder = this.main.querySelector('.list_price_holder');

        this._isListPriceSticky = false;

        this._addedToList = false;
        
        this._checkboxExclusivity = this.main.querySelector('input[name="exclusivity"]');
        this._checkboxExclusivityHolder = this.main.querySelector('.checkbox_exclusivity_holder');
        
        this._isStatic = [Billboards.FORMAT_STATIC, Billboards.FORMAT_OTHER_MEDIA].includes(Number(billboardFormatId));
        if(this._isStatic){
            this._checkboxExclusivityHolder.style.display = 'none';
        }
        
        window.addEventListener('scroll', this._onScroll.bind(this));
        Auth.addEventListener('sessionReady', this._onSessionReady.bind(this));
    }

    _onSessionReady(isUserLogged){
        if(Auth.isCustomerLogged && !Auth.isExternalSellerLogged){
            BrandSelector.addEventListener('brandChange', this._onBrandCategoryOrBrandChange.bind(this));
        }else if(Auth.isExternalSellerLogged) {
            ClientSelector.addEventListener('brandChange', this._onBrandCategoryOrBrandChange.bind(this));
        }else{
            this._brandCategorySelector.addEventListener('brandCategoryChange', this._onBrandCategoryOrBrandChange.bind(this));
        }

        this.dateRangePicker.addEventListener('dateRangeChange', this._onDateRangePickerChange.bind(this));
        this.dateRangePicker.addEventListener('selectedDayChange', this._onSelectDay.bind(this));
        this._checkboxExclusivity.addEventListener('change', this._onExclusivityCheckboxChange.bind(this));
        this._addToListBtn.addEventListener('click', this._onClickAddToListBtn.bind(this));
        this._daysAvailableBtn.addEventListener('click', this._onClickDaysAvailableBtn.bind(this));
    }

    set dateRange(dateRange){
        this.dateRangePicker.dateRange = dateRange;
    }

    set brandCategoryId(brandCategoryId){
        if(!(Auth.isCustomerLogged || Auth.isExternalSellerLogged)){
            this._brandCategorySelector.value = brandCategoryId;
        }
    }

    set brandId(brandId){
        if (Auth.isCustomerLogged) {
            BrandSelector.value = brandId;
        }

        if (Auth.isExternalSellerLogged) {
            ClientSelector.addEventListener('loadingEnd', () => {
                ClientSelector.value = brandId;
                this._dispatchChange();
            })
        }
    }

    set exclusivity(exclusivity){
        this._checkboxExclusivity.checked = exclusivity;
    }

    set(price, cpm, days_available){
        // this._reach.innerHTML = formatBigNumber(days_available*visibility);
        this._cpm.innerHTML = formatCPM(cpm);
        this._avgDayPrice.innerHTML = days_available == 0 ? formatPrice(0) : formatPrice(price/days_available);
        this._priceElements.forEach((element)=>{
            element.innerHTML = formatPrice(price);
            this.dataPrice = price;
        });

        let totalDays = (this.dateRangePicker.dateRange.to.getTime() - this.dateRangePicker.dateRange.from.getTime())/(1000 * 3600 * 24) + 1;
        
        this._daysAvailableBtn.innerHTML = `${days_available} of ${totalDays} days available`;

        if((Auth.isCustomerLogged && !Auth.isExternalSellerLogged) && BrandSelector.value == null){
            BrandSelector.showTooltip();
        }
        if((Auth.isCustomerLogged && Auth.isExternalSellerLogged) && BrandSelector.value == null){
            ClientSelector.showTooltip();
        }

        if(!(Auth.isCustomerLogged) && this._brandCategorySelector.value == null){
            this._brandCategorySelector.showTooltip();
        }

        if(!this._addedToList){
            let brandOrBrandCategorySelected = false;
            if(Auth.isCustomerLogged && !Auth.isExternalSellerLogged && BrandSelector.value == null ){
                brandOrBrandCategorySelected = true;
            }else if(!Auth.isCustomerLogged && !Auth.isExternalSellerLogged && this._brandCategorySelector.value == null ){
                brandOrBrandCategorySelected = true;
            }else if(Auth.isExternalSellerLogged && ClientSelector.value == null ){
                brandOrBrandCategorySelected = true;
            }

            if(days_available == 0 || brandOrBrandCategorySelected){
                this._addToListBtn.classList.add('button--disabled');
            }else{
                this._addToListBtn.classList.remove('button--disabled');
            }
        }
        
        if (Auth.isUserLogged) {
            const parentDiv = this._addToListBtn.parentNode;
            parentDiv.classList.remove('tooltip');
        } else {
            this._addToListBtn.classList.add('button--disabled');
        }
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    set addedToList(value){
        this._addedToList = value;

        if(this._addedToList){
            this._addToListBtn.classList.add('button--disabled');
            this._addToListBtn.innerHTML = 'Added to your list';
        }else{
            this._addToListBtn.classList.remove('button--disabled');
            this._addToListBtn.innerHTML = 'Add to list';
        }
    }

    set addToListDisabled(disabled){
        if (disabled) {
            this._addToListBtn.classList.add('button--disabled');
        } else {
            this._addToListBtn.classList.remove('button--disabled');
        }
    }


    _onClickAddToListBtn(e){
        e.preventDefault();
        gaSendEvent('Billboard Detail', 'Click Add To List', 'Billboard Detail Price Detail');
        GTMEvent('add_to_cart',{ecommerce: {currency:'USD', tax: '0', shipping:'0', value: this.dataPrice, items:[{item_id: this.dataId, item_name: this.dataName, price: this.dataPrice, quantity:'1'}]}});
        this.main.dispatchEvent(new CustomEvent('addToList'));
    }

    _onDateRangePickerChange(e){
        this._dispatchChange();
    }

    _onSelectDay(e) {
        this._dispatchChange();
    }

    _onBrandCategoryOrBrandChange(e){
        this._dispatchChange();
    }

    _onExclusivityCheckboxChange(e){
        this._dispatchChange();
    }

    _dispatchChange(){
        let brandId = null;
        if(Auth.isExternalSellerLogged) {
            brandId = ClientSelector.value;
        } else if(Auth.isCustomerLogged) {
            brandId = BrandSelector.value;
        }
        
        this.main.dispatchEvent(new CustomEvent('filterChanged', {
            detail:{
                dateRange: this.dateRangePicker.dateRange,
                weekdays: this.dateRangePicker._modal._daysSelected,
                brandId,
                brandCategoryId: !(Auth.isCustomerLogged) ? this._brandCategorySelector.value : null,
                exclusivity: this._isStatic ? false : this._checkboxExclusivity.checked
            }
        }));
    }

    _onClickDaysAvailableBtn(e){
        e.preventDefault();
        
        this.main.dispatchEvent(new CustomEvent('showDatesAvailable'));
    }

    _onScroll(e){
        if(this.dateRangePicker.isOpen){
            this.dateRangePicker.hide(); 
        }
        
        if(window.pageYOffset > this.main.parentElement.offsetTop + this.main.offsetHeight + 220){
            if(!this._isListPriceSticky){
                this._isListPriceSticky = true;
                
                this._listPriceHolder.classList.add('card-box__add-quoute--sticky');
                setTimeout(()=>{
                    this._listPriceHolder.classList.add('card-box__add-quoute--show');
                }, 100)
            }
        }else{
            if(this._isListPriceSticky){
                this._isListPriceSticky = false;
                
                this._listPriceHolder.classList.remove('card-box__add-quoute--show');
                setTimeout(()=>{
                    this._listPriceHolder.classList.remove('card-box__add-quoute--sticky');
                }, 500);
            }            
        }
    }

    show() {
        this.main.classList.remove('d-none');
    }

    hide() {
        this.main.classList.add('d-none');
    }
}

export default BillboardDetailPriceDetail;